import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../shared/redux/types";
import { LIST_OF_PERFORMANCE_DATA } from "../constants";
import { cloneDeep, isArray } from "lodash";
import axios from "axios";
import {
  setEditData,
  setEditDialogOpen,
  setPerformanceData,
  updatePerformanceData,
} from "../../../shared/redux/action/performance.action";
import { useAppDispatch } from "../../../shared/redux/hooks";
import {
  Button,
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
  SpinnerLoader,
  Toastify,
  Switch,
  SingleSelect,
  Input,
  Label,
} from 'lift-ui';
import { Textarea } from "@/components/ui/textarea";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import "../add_accounts/add_accounts.scss";
import apiClient from "@lift-admin/utils/apiClient";
import { actionLog } from "../../../App";
import { buildSummary } from "@lift-admin/utils/logChangeFormatter";
import { Info } from "lucide-react";
import TagInput from "../../../shared/components/tag-input";
import { diffPerformanceAccountForLog } from "../logFields";

const EditPerformance = ({
  calledFromWhichComponent,
  onSave,
}: {
  calledFromWhichComponent: any;
  onSave?: () => void;
}) => {
  const dispatch = useAppDispatch();
  const {
    editDialogOpen,
    editData,
    performanceData,
  }: { editData: any; editDialogOpen: any; performanceData: any } = useSelector(
    (state: RootState) => state.performance
  );

  //filtered JSON data for rendering field
  const [filteredJSONData, setFilteredJsonData] = useState<any>([]);
  //performanceData
  const [editPerformanceData, setEditPerformanceData] = useState<any>([]);
  const [editChangeItem, setEditChangeItem] = useState<any>(null);
  const [dataSources, setDataSources] = useState<any>([]);
  const [selectedDropdownValue, setSelectedDropdownValue] = useState<any>(null);
  const [nestedDropdownValues, setNestedDropdownValues] = useState<any>({});
  const [isLoading, setIsLoading] = useState<any>(false);
  const [isSaveClicked, setIsSaveClicked] = useState<any>(false);
  const [lastModifiedColumns, setLastModifiedColumns] = useState([]);

  console.log(editData, 'editData')
  useEffect(() => {
    //filter JSON data based on editData for rendering fields
    if (editData) {
      // Create a deep copy to avoid mutating Redux state
      const editDataCopy = cloneDeep(editData);

      editDataCopy.is_mbm = editDataCopy.is_mbm ? "Yes" : "No";
      editDataCopy.is_emq = editDataCopy.is_emq ? "Yes" : "No";
      editDataCopy.source_of_truth = editDataCopy.source_of_truth ? "Yes" : "No";
      editDataCopy.is_automation_enabled = editDataCopy.is_automation_enabled ? "Yes" : "No";
      
      // Parse account_config string to individual fields
      if (editDataCopy.account_config) {
        const configPairs = editDataCopy.account_config.split(";");
        configPairs.forEach((pair: string) => {
          const [key, value] = pair.split("=");
          if (key === "keyword_level_needed") {
            editDataCopy.keyword_level_needed = value === "true" ? "Yes" : "No";
          }
          if (key === "is_enterprise_client") {
            editDataCopy.is_enterprise_client = value === "true" ? "All UTMs Level" : "Campaign Level UTM";
          }
        });
      }
      // Set defaults if not present
      if (!editDataCopy.keyword_level_needed) {
        editDataCopy.keyword_level_needed = "No";
      }
      if (!editDataCopy.is_enterprise_client) {
        editDataCopy.is_enterprise_client = "Campaign Level UTM";
      }
      
      let filteredData: any = LIST_OF_PERFORMANCE_DATA.filter(
        (item: any) => item.formal_name === editDataCopy.formal_name
      );

      if (filteredData.length === 0) {
        filteredData = [
          LIST_OF_PERFORMANCE_DATA.find(
            (item: any) => item.formal_name === "Client System"
          ),
        ];

        editDataCopy["type"] = "Free Form Text";
      }

      setFilteredJsonData(filteredData);
      setEditPerformanceData([editDataCopy]);

      if (!isArray(editDataCopy.selected_conversion_tag_names)) {
        if (!editDataCopy.selected_conversion_tag_names) {
          editDataCopy.selected_conversion_tag_names = [];
        } else {
          let arr = [];
          arr = editDataCopy?.selected_conversion_tag_names?.split(",");
          editDataCopy.selected_conversion_tag_names = arr;
        }
      }

      if (
        editDataCopy.formal_name === "Meta Ads" &&
        editDataCopy?.attribution_window?.includes("/")
      ) {
        setEditChangeItem({
          ...editDataCopy,
          selectedDropdownValue: "Define Window",
        });
      } else if (
        editDataCopy.formal_name === "Meta Ads" &&
        editDataCopy?.attribution_window?.includes("DEFAULT")
      ) {
        setEditChangeItem({
          ...editDataCopy,
          attribution_window: "Use unified attribution",
          selectedDropdownValue: "Use unified attribution",
        });
      } else {
        setEditChangeItem(editDataCopy);
      }
    }
  }, [editData]);

  console.log(editData, 'verify editData');


  //getDisplay Names from Google Sheet
  const getDataSourcesNames = async () => {
    try {
      const response = await axios.get(
        "https://script.googleusercontent.com/a/macros/newengen.com/echo?user_content_key=mRWlWTCv6ZMdbTbGRJqBSGDYI_CjdpIGXouDh_3wqhQ0GB4Fu_JFRZ_LnbM8v-RXezxmUxdmJj_UIl5KYj32Vbr4K0DQ3RJ7OJmA1Yb3SEsKFZqtv3DaNYcMrmhZHmUMi80zadyHLKBw98rs-s2Hwv7hp7eZt5FU68n4RAo2RJz2eHM1tPVCsa3Zh-JLoTbPVypxk8kIK7_Tt9HYH5pdz0KEumnpWIuFDX48PxEKDtV9abvbb2kQrot_ELmeDD2YOdwyHrBXXtzc_ScPTHfLrg&lib=M9tSS4uqL-njC3k6PSa5Z6PTYFf-Ccci9"
      );

      setDataSources(response.data.data);
    } catch (error: any) { }
  };

  useEffect(() => {
    getDataSourcesNames();
  }, []);

  //checking for required field
  //function for validation logic for selected_conversion_event and tags ( one required if another left empty )
  const isFieldRequired = (validation: any) => {
    if (typeof validation.required === "object") {
      const { dependent_field, required_if_empty } = validation.required;

      // Determine the current item (editChangeItem or editChangeItem)

      // Get the value of the dependent field from the current item
      const dependentValue = editChangeItem?.[dependent_field];

      // If the dependent field is required_if_empty, check if it's empty
      return required_if_empty && !dependentValue;
    }

    // If validation.required is not an object, return its boolean value
    return validation.required;
  };

  //for textfield value change
  //handleChange fn for changing the input fields
  const handleValueChange = (e: any) => {
    // If 'is_mbm' is changed to "Yes", update other "Meta Ads" entries
    if (e.target.name === "is_mbm" && e.target.value === "Yes") {
      // Similarly, update `performanceData` immutably
      const updatedPerformanceData = performanceData.map((data: any) => {
        if (data.formal_name === "Meta Ads" && editChangeItem?.id !== data.id) {
          return {
            ...data,
            is_mbm: "No",
          };
        }
        return data;
      });

      // Dispatch the updated performance data to Redux store
      dispatch(setPerformanceData(updatedPerformanceData));
    }

    const new_change_item = cloneDeep(editChangeItem);

    if (
      (e.target.name === "selected_conversion_event" ||
        e.target.id === "selected_conversion_event") &&
      editChangeItem["formal_name"] === "Meta Ads"
    ) {
      if (new_change_item.is_emq === "Yes") {
        new_change_item.emq_primary_conversion = e.target.value;
      } else {
        new_change_item.emq_primary_conversion = "";
      }
    }
    new_change_item[e.target.name ? e.target.name : e.target.id] =
      e.target.value;

    setEditChangeItem(new_change_item);
  };



  //handling onChange of array i.e tag names
  const validateFields = (
    index: number,
    itemToValidate: Record<string, any>
  ) => {
    if (itemToValidate) {
      //all the values that are required and not provided will remain in this array
      let required_arr: string[] = [];

      const entries = Object.entries(filteredJSONData[index].fields);

      for (const [key, value] of entries as [string, any][]) {
        if (
          key === "emq_primary_conversion" &&
          itemToValidate?.is_emq === "No"
        ) {
          continue;
        }

        if (typeof value.validation?.required === "object") {
          if (
            itemToValidate[key] === "" &&
            itemToValidate[value.validation?.required.dependent_field]
              .length === 0
          ) {
            Toastify(
              "error",
              `Please provide either ${key.replace(/_/g, " ")} or ${String(value.validation?.required?.dependent_field || "").replace(/_/g, " ")}.`
            );
            return true;
          }
        }

        if (
          value.validation?.required &&
          typeof value.validation?.required != "object"
        ) {
          required_arr.push(key);
        }

        // Only validate pattern when field has a value (empty = required check, not format)
        const fieldVal = itemToValidate[key];
        if (value.validation?.pattern && fieldVal !== "" && fieldVal != null) {
          const regex = new RegExp(value.validation.pattern[0]);
          if (!regex.test(String(fieldVal))) {
            Toastify("error", value.validation.pattern[1]);
            return true;
          }
        }
      }

      required_arr = required_arr.filter(
        (field: string) =>
          itemToValidate[field] === "" || itemToValidate[field] === null
      );

      if (required_arr.length > 0) {
        Toastify("error", "Please fill in all required fields.");
        return true;
      }
    }
  };

  const handleNestedDropdownChange = (
    e: any,
    key: any,
    options: any,
    itemToChange: any,
    setItemToChange: any
  ) => {
    const newChangeItem = cloneDeep(itemToChange);

    options.forEach((item: any) => {
      if (typeof item === "string" && item === e.target.value) {
        newChangeItem[key] = e.target.value;
      } else if (typeof item === "object" && item.label === e.target.value) {
        newChangeItem[key] = null;
      }
    });
    newChangeItem["selectedDropdownValue"] = e.target.value;
    setItemToChange(newChangeItem);
  };

  const handleChangeMultipleDropdownVal = (
    e: any,
    key: any,
    value: any,
    index: any,
    itemToChange: any,
    setItemToChange: any
  ) => {
    const new_change_item = cloneDeep(itemToChange);

    const val = new_change_item[key];

    let arr;
    if (val) {
      arr = val.split("/");
    } else {
      arr = new Array(value?.children?.length).fill(null);
    }

    arr[index] = e.target.value;

    new_change_item[key] = arr.join("/");

    setItemToChange(new_change_item);
  };

  // Save & Close: validate, build payload, call API, then close (single step)
  const handleSaveAndClose = async () => {
    const user = JSON.parse(localStorage.getItem("user") || "");
    if (!editChangeItem) return;
    setIsSaveClicked(true);
    if (await validateFields(0, editChangeItem)) {
      const errorDesc = {
        message: `Validation failed while updating performance account "${editChangeItem?.account_name || "N/A"}"`,
        category: "performance",
        action: "validation_failed",
        user_id: user.id,
        user_name: user.name,
        account_id: editChangeItem?.account_id || null,
        account_name: editChangeItem?.account_name || null,
        brand_id: editData?.brand_id || null,
        brand_name: editData?.brand_name || null,
      };
      await actionLog?.actionLogTrack(JSON.stringify(errorDesc), true);
      return;
    }
    const modifiedColumns = changesDetect(editChangeItem, editPerformanceData[0]);
    const payload = buildUpdatePayload(editChangeItem, modifiedColumns);
    const accountChanges = diffPerformanceAccountForLog(
      editPerformanceData[0],
      editChangeItem
    );

    if (calledFromWhichComponent?.toLowerCase() === "media platform accounts") {
      try {
        await apiClient.put(`/brand/v1/paid_ad_accounts/update/${payload.id}`, payload);
        setEditPerformanceData([]);
        setEditChangeItem(null);
        dispatch(setEditDialogOpen(false));
        dispatch(setEditData(null));
        Toastify("success", "Performance Updated Successfully");
        onSave?.();
        try {
          const desc = {
            message: buildSummary(
              "Performance account",
              editData?.account_name,
              "updated",
              accountChanges.length
            ),
            status: 200,
            method: "PUT",
            url: `/brand/v1/paid_ad_accounts/update/${payload.id}`,
            category: "performance",
            action: "update_paid_ad_account",
            account_id: editData?.account_id,
            account_name: editData?.account_name,
            brand_id: editData?.brand_id || null,
            brand_name: editData?.brand_name || null,
            user_id: user.id,
            user_name: user.name,
            changes: accountChanges,
          };
          await actionLog?.actionLogTrack(JSON.stringify(desc), false);
        } catch (logError) {
          console.error("Action log tracking failed:", logError);
        }
      } catch (err: any) {
        const errorDesc = {
          message: `Failed to update performance account "${editData?.account_name || "N/A"}": ${err.response?.data?.message || err.response?.message || err.message}`,
          status: err.response?.status,
          method: "PUT",
          url: `/brand/v1/paid_ad_accounts/update/${payload.id}`,
          category: "performance",
          action: "update_paid_ad_account",
          account_id: editData?.account_id,
          account_name: editData?.account_name,
          brand_id: editData?.brand_id || null,
          brand_name: editData?.brand_name || null,
          user_id: user.id,
          user_name: user.name,
          changes: accountChanges,
        };
        await actionLog?.actionLogTrack(JSON.stringify(errorDesc), true);
        Toastify("error", `Failed to update performance: ${err.response?.data?.message ?? err.response?.message ?? err.message ?? "Please try again."}`);
      }
    } else {
      dispatch(updatePerformanceData(editPerformanceData[0].id - 1, editChangeItem));
      setEditChangeItem(null);
      setEditPerformanceData([]);
      dispatch(setEditDialogOpen(false));
      dispatch(setEditData(null));
      Toastify("success", "Performance Updated Successfully");
      try {
        const desc = {
          message: buildSummary(
            "Performance account",
            editData?.account_name,
            "updated",
            accountChanges.length
          ),
          category: "performance",
          action: "update_paid_ad_account",
          account_id: editData?.account_id,
          account_name: editData?.account_name,
          brand_id: editData?.brand_id || null,
          brand_name: editData?.brand_name || null,
          user_id: user.id,
          user_name: user.name,
          changes: accountChanges,
        };
        await actionLog?.actionLogTrack(JSON.stringify(desc), false);
      } catch (logError) {
        console.error("Action log tracking failed:", logError);
      }
    }
  };

  const handleSaveEditPerformance = (e: any, index: any) => {
    const isSaveAndClose = e.target.textContent?.toLowerCase().trim() === "save & close";
    const isEdit = e.target.textContent?.toLowerCase().trim() === "edit";
    if (isSaveAndClose) {
      handleSaveAndClose();
    } else if (isEdit) {
      setEditChangeItem(cloneDeep(editPerformanceData[0]));
    }
  };

  const changesDetect = (item: any, originalData: any) => {
    const modifiedColumns: any = [];
    if (!item || !originalData) return modifiedColumns;
    Object.keys(originalData).forEach((key) => {
      if (key === "selected_conversion_tag_names") {
        const origArray = originalData[key] || [];
        const itemArray = item[key] || [];
        if (origArray.length !== itemArray.length) {
          modifiedColumns.push(key);
        } else {
          const arraysEqual = origArray.every((val: any, idx: number) => val === itemArray[idx]);
          if (!arraysEqual) modifiedColumns.push(key);
        }
      } else if (originalData[key] !== item[key]) {
        modifiedColumns.push(key);
      }
    });
    setLastModifiedColumns(modifiedColumns);
    return modifiedColumns;
  };

  const buildUpdatePayload = (data: any, modifiedColumns: any[]) => {
    const user = JSON.parse(localStorage.getItem("user") || "");
    const d = { ...data };
    if (d.type) d.formal_name = d.account_id?.split("_")[0];
    delete d.selectedDropdownValue;
    delete d?.type;
    const configParts: string[] = [];
    if (d.formal_name === "Microsoft Ads") {
      configParts.push(`keyword_level_needed=${d.keyword_level_needed === "Yes" ? "true" : "false"}`);
    }
    if (d.formal_name === "Google Analytics Data") {
      configParts.push(`is_enterprise_client=${d.is_enterprise_client === "All UTMs Level" ? "true" : "false"}`);
    }
    const accountConfig = configParts.length > 0 ? configParts.join(";") : null;
    const { keyword_level_needed, is_enterprise_client, ...restData } = d;
    const updatedItem = {
      ...restData,
      last_modified_column: modifiedColumns,
      modified_by: user.name,
      is_mbm: d.is_mbm === "Yes",
      is_emq: d.is_emq === "Yes",
      source_of_truth: d.source_of_truth === "Yes",
      is_automation_enabled: d.is_automation_enabled === "Yes",
      attribution_window:
        d?.attribution_window !== "" && d?.attribution_window != null
          ? d?.attribution_window?.includes("/")
            ? d?.attribution_window
            : "Default"
          : undefined,
      account_config: accountConfig,
    };
    return Object.fromEntries(Object.entries(updatedItem).filter(([_, v]) => v != null));
  };

  const handleCloseEditPerformanceDialog = async () => {
    if (!editChangeItem) {
      const user = JSON.parse(localStorage.getItem("user") || "");
      //updatedData with last_modified_column and modified_by
      const updatedData = editPerformanceData.map((data: any) => {
        if (data.type) {
          data.formal_name = data.account_id.split("_")[0];
        }
        delete data.selectedDropdownValue;
        delete data?.type;
        
        // Build account_config string from config fields
        const configParts: string[] = [];
        // keyword_level_needed is only for Microsoft Ads
        if (data.formal_name === "Microsoft Ads") {
          configParts.push(`keyword_level_needed=${data.keyword_level_needed === "Yes" ? "true" : "false"}`);
        }
        // is_enterprise_client is only for GA4
        if (data.formal_name === "Google Analytics Data") {
          configParts.push(`is_enterprise_client=${data.is_enterprise_client === "All UTMs Level" ? "true" : "false"}`);
        }
        const accountConfig = configParts.length > 0 ? configParts.join(";") : null;

        // Remove temporary config fields
        const { keyword_level_needed, is_enterprise_client, ...restData } = data;
        
        const updatedItem = {
          ...restData,
          last_modified_column: lastModifiedColumns,
          modified_by: user.name,
          is_mbm: data.is_mbm === "Yes",
          is_emq: data.is_emq === "Yes",
          source_of_truth: data.source_of_truth === "Yes",
          is_automation_enabled: data.is_automation_enabled === "Yes",
          attribution_window:
            data?.attribution_window !== ""
              ? data?.attribution_window?.includes("/")
                ? data?.attribution_window
                : "Default"
              : undefined, // Change null to undefined to remove it later
          account_config: accountConfig,
        };

        // Remove null or undefined values
        return Object.fromEntries(
          Object.entries(updatedItem).filter(([_, v]) => v != null)
        );
      });

      if (
        calledFromWhichComponent.toLowerCase() === "media platform accounts"
      ) {
        await apiClient
          .put(
            `/brand/v1/paid_ad_accounts/update/${updatedData[0].id}`,
            updatedData[0]
          )
          .then(async (res) => {
            // Close dialog and show success first
            setEditPerformanceData([]);
            dispatch(setEditDialogOpen(false));
            Toastify("success", "Performance Updated Successfully");

            // Action log tracking (non-blocking)
            try {
              const closeAccountChanges = diffPerformanceAccountForLog(
                editData,
                updatedData[0]
              );
              const desc = {
                message: buildSummary(
                  "Performance account",
                  editData?.account_name,
                  "updated",
                  closeAccountChanges.length
                ),
                status: res.status,
                method: res.config.method,
                url: res.config.url,
                category: "performance",
                action: "update_paid_ad_account",
                account_id: editData?.account_id,
                account_name: editData?.account_name,
                brand_id: editData?.brand_id || null,
                brand_name: editData?.brand_name || null,
                user_id: user.id,
                user_name: user.name,
                changes: closeAccountChanges,
              };
              await actionLog?.actionLogTrack(JSON.stringify(desc), false);
            } catch (logError) {
              console.error("Action log tracking failed:", logError);
            }
          })
          .catch(async (err: any) => {
            const errorDesc = {
              message: `Failed to update performance account "${editData?.account_name || "N/A"}": ${err.response?.data?.message || err.response?.message || err.message}`,
              status: err.response?.status,
              method: "PUT",
              url: `/brand/v1/paid_ad_accounts/update/${updatedData[0].id}`,
              category: "performance",
              action: "update_paid_ad_account",
              account_id: editData?.account_id,
              account_name: editData?.account_name,
              brand_id: editData?.brand_id || null,
              brand_name: editData?.brand_name || null,
              user_id: user.id,
              user_name: user.name,
            };
            await actionLog?.actionLogTrack(JSON.stringify(errorDesc), true);
            Toastify("error", `Failed to update performance: ${err.response?.data?.message ?? err.response?.message ?? err.message ?? "Please try again."}`);
          });
      } else {
        dispatch(
          updatePerformanceData(
            editPerformanceData[0].id - 1,
            editPerformanceData[0]
          )
        );
        setEditChangeItem(null);
        setEditPerformanceData([]);
        dispatch(setEditDialogOpen(false));
        Toastify("success", "Performance Updated Successfully");
      }
    } else {
      Toastify("error", "Please save your changes before closing.");
    }
  };

  return (
    <>
      <Sheet open={editDialogOpen} onOpenChange={(open) => {
        if (!open) {
          dispatch(setEditDialogOpen(false));
          dispatch(setEditData(null));
          setEditChangeItem(null);
          setEditPerformanceData([]);
        }
      }}>
        <SheetContent className="sm:max-w-3xl flex flex-col" onInteractOutside={(e) => e.preventDefault()}>
          <SheetHeader>
            <SheetTitle>Edit Performance</SheetTitle>
          </SheetHeader>
          <div className="flex-1 overflow-y-auto py-6">
            <div className="space-y-6">
                {editPerformanceData.length > 0 &&
                  editPerformanceData.map((item: any, index: any) => {
                    const isDisabled = !editChangeItem;
                    return (
                      <React.Fragment key={index}>
                        <div className="bg-white rounded-lg border border-gray-200 p-6">
                          <div className="text-lg font-semibold text-gray-900 mb-4">
                            {item.display_name}
                          </div>

                          {(() => {
                            const entries = Object.entries(filteredJSONData[index].fields);
                            const regularFields: [string, any][] = [];
                            const switchFields: [string, any][] = [];
                            const textareaFields: [string, any][] = [];
                            const toggleDependentFields: [string, any][] = [];

                            entries.forEach(([key, value]: [string, any]) => {
                              if (value.validation?.allow_na || value.validation?.allow_tbd) return;
                              const isConversionField =
                                value.label === "Primary Conversion" ||
                                value.label === "Secondary Conversion" ||
                                value.label === "Tertiary Conversion";
                              if (value.type === "switch") switchFields.push([key, value]);
                              else if (value.type === "textarea") textareaFields.push([key, value]);
                              else if (isConversionField) toggleDependentFields.push([key, value]);
                              else regularFields.push([key, value]);
                            });

                            const showConversionFields =
                              (editChangeItem?.is_emq === "Yes") ||
                              (!editChangeItem && item?.is_emq === "Yes");

                            return (
                              <>
                                {/* Regular fields in 2-column grid */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
                                  {regularFields.map(([key, value]: [string, any]) => {
                                    return (
                                      <React.Fragment key={key}>
                                        {/* Text fields */}
                                        {value.type === "text" && (
                                          <div className="space-y-1.5">
                                            <Label htmlFor={key}>
                                              {value.label}
                                              {isFieldRequired(value.validation) && <span className="text-red-500 ml-1">*</span>}
                                            </Label>
                                            <Input
                                              id={key}
                                              name={key}
                                              onChange={(e) => handleValueChange(e)}
                                              disabled={isDisabled}
                                              value={editChangeItem ? editChangeItem[key] : item[key]}
                                              className={
                                                typeof value.validation?.required !== "object" &&
                                                editChangeItem?.id === item.id &&
                                                editChangeItem[key] === "" &&
                                                isSaveClicked &&
                                                value.validation?.required
                                                  ? "border-red-500"
                                                  : ""
                                              }
                                            />
                                          </div>
                                        )}

                                        {/* Simple Dropdown */}
                                        {value.type === "dropdown" && (
                                          <div className="space-y-1.5">
                                            <div className="flex items-center gap-1">
                                              <Label htmlFor={key}>{value.label}</Label>
                                              {(isDisabled || (value.label === "Backfill Status" && !item.is_prospect)) && (
                                                <Tooltip>
                                                  <TooltipTrigger asChild>
                                                    <Info className="h-3.5 w-3.5 text-muted-foreground" />
                                                  </TooltipTrigger>
                                                  <TooltipContent>
                                                    {isDisabled ? "Please save changes first" :
                                                      value.label === "Backfill Status" && !item.is_prospect ?
                                                        "Backfill Status can only be modified for prospect accounts" : ""}
                                                  </TooltipContent>
                                                </Tooltip>
                                              )}
                                            </div>
                                            <SingleSelect
                                              options={value?.options?.map((opt: any) => ({
                                                label: opt,
                                                value: opt,
                                              })) || []}
                                              defaultValue={
                                                editChangeItem?.id === item.id
                                                  ? editChangeItem[key]
                                                  : item[key]
                                              }
                                              onChange={(val) => {
                                                handleValueChange({ target: { name: key, value: val } } as any);
                                              }}
                                              disabled={isDisabled || (value.label === "Backfill Status" && !item.is_prospect)}
                                              containerClassName="w-full"
                                            />
                                          </div>
                                        )}

                                        {/* Multiple Dropdown */}
                                        {value?.type === "multiple-dropdown" &&
                                          value?.options.map((subItem: any, subItemIndex: number) => (
                                            <React.Fragment key={`multi-${subItemIndex}`}>
                                              {subItem?.children?.map(
                                                (subDropdown: any, subIndex: any) => (
                                                  <div key={subIndex} className="space-y-1.5">
                                                    <Label>{subDropdown.label}</Label>
                                                    <SingleSelect
                                                      options={subDropdown?.options?.map((data: any) => ({
                                                        label: data.value,
                                                        value: data.value,
                                                      })) || []}
                                                      defaultValue={
                                                        editChangeItem?.id === item.id
                                                          ? editChangeItem[key]?.split("/")[subIndex]
                                                          : item[key]?.split("/")[subIndex]
                                                      }
                                                      onChange={(val) => {
                                                        handleChangeMultipleDropdownVal(
                                                          { target: { value: val } } as any,
                                                          key,
                                                          value.options[0],
                                                          subIndex,
                                                          editChangeItem,
                                                          setEditChangeItem
                                                        );
                                                      }}
                                                      disabled={isDisabled}
                                                      containerClassName="w-full"
                                                    />
                                                  </div>
                                                )
                                              )}
                                            </React.Fragment>
                                          ))
                                        }

                                        {/* Nested Dropdown (e.g. Attribution Window) */}
                                        {value.type === "nested-dropdown" && (
                                          <>
                                            <div className="space-y-1.5">
                                              <Label>{value.label}</Label>
                                              <SingleSelect
                                                options={value?.options?.map((opt: any) => ({
                                                  label: opt.label ? opt.label : opt,
                                                  value: opt.label ? opt.label : opt,
                                                })) || []}
                                                defaultValue={
                                                  editChangeItem?.id === item.id
                                                    ? editChangeItem["selectedDropdownValue"]
                                                    : item[key]?.includes("/")
                                                      ? item["selectedDropdownValue"]
                                                      : item[key]
                                                }
                                                onChange={(val) => {
                                                  handleNestedDropdownChange(
                                                    { target: { value: val } } as any,
                                                    key,
                                                    value.options,
                                                    editChangeItem,
                                                    setEditChangeItem
                                                  );
                                                }}
                                                disabled={isDisabled}
                                                containerClassName="w-full"
                                              />
                                            </div>

                                            {/* Nested dropdown children as separate grid items */}
                                            {value.options.map(
                                              (nestedItem: any, nestedItemIndex: number) => (
                                                <React.Fragment key={`nested-${nestedItemIndex}`}>
                                                  {typeof nestedItem === "object" &&
                                                    ((editChangeItem?.id === item.id &&
                                                      nestedItem?.label === editChangeItem["selectedDropdownValue"]) ||
                                                      nestedItem.label === item["selectedDropdownValue"]) &&
                                                    nestedItem?.children?.map(
                                                      (nestedDropDown: any, nestedDropDownIndex: number) => (
                                                        <div key={nestedDropDownIndex} className="space-y-1.5">
                                                          <Label>{nestedDropDown.label}</Label>
                                                          <SingleSelect
                                                            options={nestedDropDown?.options?.map((opt: any) => ({
                                                              label: opt.label,
                                                              value: opt.value,
                                                            })) || []}
                                                            defaultValue={
                                                              editChangeItem?.id === item.id
                                                                ? editChangeItem[key]?.includes("/")
                                                                  ? editChangeItem[key].split("/")[nestedDropDownIndex]
                                                                  : ""
                                                                : item[key]?.split("/")[nestedDropDownIndex]
                                                            }
                                                            onChange={(val) => {
                                                              handleChangeMultipleDropdownVal(
                                                                { target: { value: val } } as any,
                                                                key,
                                                                nestedItem,
                                                                nestedDropDownIndex,
                                                                editChangeItem,
                                                                setEditChangeItem
                                                              );
                                                            }}
                                                            disabled={isDisabled}
                                                            containerClassName="w-full"
                                                          />
                                                        </div>
                                                      )
                                                    )}
                                                </React.Fragment>
                                              )
                                            )}
                                          </>
                                        )}

                                        {/* Array (tag input) */}
                                        {value.type === "array" && (
                                          <div className="col-span-1 md:col-span-1">
                                            <TagInput
                                              id={key}
                                              label={value.label}
                                              placeholder="Type and Enter (tag value)"
                                              disabled={isDisabled}
                                              value={(editChangeItem ? editChangeItem[key] : item[key]) ?? []}
                                              singleLine={key === "selected_conversion_tag_names"}
                                              onChange={(newTags: string[]) => {
                                                if (editChangeItem?.id === item.id) {
                                                  const new_change_item = cloneDeep(editChangeItem);
                                                  new_change_item[key] = newTags;
                                                  setEditChangeItem(new_change_item);
                                                }
                                              }}
                                            />
                                          </div>
                                        )}
                                      </React.Fragment>
                                    );
                                  })}
                                </div>

                                {/* Toggles grouped in a grid */}
                                {switchFields.length > 0 && (
                                  <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-3 mt-5 pt-4 border-t border-gray-100">
                                    {switchFields.map(([key, value]: [string, any]) => (
                                      <div key={key} className="flex items-center justify-between gap-2 min-h-[36px]">
                                        <div className="flex items-center gap-1">
                                          <span className="text-sm font-medium leading-none">
                                            {value.label}
                                          </span>
                                          {value?.tooltip && (
                                            <Tooltip>
                                              <TooltipTrigger asChild>
                                                <Info className="h-3.5 w-3.5 text-muted-foreground" />
                                              </TooltipTrigger>
                                              <TooltipContent>{value.tooltip}</TooltipContent>
                                            </Tooltip>
                                          )}
                                        </div>
                                        <Switch
                                          checked={
                                            editChangeItem?.id === item.id
                                              ? editChangeItem[key] === "Yes"
                                              : item[key] === "Yes"
                                          }
                                          onCheckedChange={(checked) => {
                                            const newValue = checked ? "Yes" : "No";
                                            if (editChangeItem && editChangeItem.id === item.id) {
                                              const finalState =
                                                newValue === "No" && key === "is_emq"
                                                  ? {
                                                      ...editChangeItem,
                                                      [key]: newValue,
                                                      emq_primary_conversion: "",
                                                      emq_secondary_conversion: "",
                                                      emq_tertiary_conversion: "",
                                                    }
                                                  : {
                                                      ...editChangeItem,
                                                      [key]: newValue,
                                                    };
                                              setEditChangeItem(finalState);
                                            }
                                          }}
                                          disabled={isDisabled}
                                        />
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {/* Toggle-dependent fields (e.g. EMQ conversion fields) */}
                                {toggleDependentFields.length > 0 && showConversionFields && (
                                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5 mt-5 pt-4 border-t border-gray-100">
                                    {toggleDependentFields.map(([key, value]: [string, any]) => (
                                      <div key={key} className="space-y-1.5">
                                        <div className="flex items-center gap-1">
                                          <Label htmlFor={key}>
                                            {value.label}
                                            {isFieldRequired(value.validation) && <span className="text-red-500 ml-1">*</span>}
                                          </Label>
                                          {value?.iButton && (
                                            <Tooltip>
                                              <TooltipTrigger asChild>
                                                <Info className="h-3.5 w-3.5 text-muted-foreground" />
                                              </TooltipTrigger>
                                              <TooltipContent>
                                                Entered text should match the actual conversion value
                                              </TooltipContent>
                                            </Tooltip>
                                          )}
                                        </div>
                                        <Input
                                          id={key}
                                          name={key}
                                          onChange={(e) => handleValueChange(e)}
                                          disabled={isDisabled}
                                          value={editChangeItem ? editChangeItem[key] : item[key]}
                                          className={
                                            typeof value.validation?.required !== "object" &&
                                            editChangeItem?.id === item.id &&
                                            editChangeItem[key] === "" &&
                                            isSaveClicked &&
                                            value.validation?.required
                                              ? "border-red-500"
                                              : ""
                                          }
                                        />
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {/* Textarea fields (full-width) */}
                                {textareaFields.length > 0 && (
                                  <div className="mt-5">
                                    {textareaFields.map(([key, value]: [string, any]) => (
                                      <div key={key} className="space-y-1.5">
                                        <Label htmlFor={key}>{value.label || "Notes"}</Label>
                                        <Textarea
                                          id={key}
                                          name={key}
                                          disabled={isDisabled}
                                          placeholder="Notes"
                                          rows={4}
                                          value={editChangeItem ? editChangeItem[key] : item[key]}
                                          onChange={(e) => handleValueChange(e)}
                                          className="resize-y"
                                        />
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </React.Fragment>
                    );
                  })}
            </div>
          </div>
          <SheetFooter className="border-t pt-4 flex justify-end gap-2">
            <Button
              variant="outline"
              onClick={async () => {
                const user = JSON.parse(localStorage.getItem("user") || "");
                dispatch(setEditDialogOpen(false));
                dispatch(setEditData(null));
                setEditChangeItem(null);
                setEditPerformanceData([]);

                // Log dialog closed without saving
                const desc = {
                  message: `Edit Performance Account dialog closed without saving for "${editData?.account_name || "N/A"}"`,
                  category: "performance",
                  action: "edit_dialog_closed_without_saving",
                  user_id: user.id,
                  user_name: user.name,
                  account_id: editData?.account_id || null,
                  account_name: editData?.account_name || null,
                  brand_id: editData?.brand_id || null,
                  brand_name: editData?.brand_name || null,
                };
                await actionLog?.actionLogTrack(JSON.stringify(desc), false);
              }}
            >
              Cancel
            </Button>
            {editPerformanceData.length > 0 && (
              <Button
                variant={editChangeItem ? "default" : "outline"}
                onClick={(e) => handleSaveEditPerformance(e, 0)}
              >
                {editChangeItem ? "Save & Close" : "Edit"}
              </Button>
            )}
          </SheetFooter>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default EditPerformance;
